import { action } from 'mobx';
import BaseStore from 'core/stores/BaseStore';
import { RateService } from 'common/data';

class RateServiceStore extends BaseStore {
	constructor(rootStore) {
		super(new RateService(rootStore.app.baasic.apiClient));
	}

	@action
	getRates = async payload => {
		const response = await this.service.getRates(payload);
		this.response = response.data;
		return response.data;
	};

	@action
	getReturnRates = async payload => {
		const response = await this.service.getReturnRates(payload);
		this.response = response.data;
		return response.data;
	};

	@action
	getRateCalculatorRates = async payload => {
		const response = await this.service.getRateCalculatorRates(payload);
		this.response = response.data;
		return response.data;
	};

	@action
	getRateCalculatorBulkRates = async payload => {
		const response = await this.service.getRateCalculatorBulkRates(payload);
		this.response = response.data;
		return response.data;
	};
}

export default RateServiceStore;



// WEBPACK FOOTER //
// ./src/modules/rate/stores/RateServiceStore.js